import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {
  computed,
} from 'vue';
import {
  useRoute,
  useRouter,
} from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'NavSignInButton',
  setup(__props) {


const router = useRouter();
const route = useRoute();

const isLoginRoute = computed(() => route.path === '/auth/login');

function onLoginClick(): void {
  const path = `/auth/${isLoginRoute.value ? 'signup' : 'login'}`;
  const redirectUrl = route.query.redirect as string | undefined;

  if (redirectUrl) {
    router.push(`${path}?redirect=${encodeURIComponent(redirectUrl)}`);
    return;
  }

  router.push(path);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    class: "btn-3 h-10 text-sm font-semibold md:text-base lg:h-12 lg:text-lg xl:h-13 xl:text-xl",
    onClick: onLoginClick
  }, _toDisplayString(isLoginRoute.value ? 'সাইন আপ' : 'লগ ইন'), 1))
}
}

})